import PaginatedListState from 'flarum/common/states/PaginatedListState';
export default class PostLikesModalState extends PaginatedListState {
  constructor(params, page) {
    if (page === void 0) {
      page = 1;
    }
    const limit = 10;
    params.page = {
      ...(params.page || {}),
      limit
    };
    super(params, page, limit);
  }
  get type() {
    return 'users';
  }
}
flarum.reg.add('flarum-likes', 'forum/states/PostLikesModalState', PostLikesModalState);